import BLMaintenanceMessage from './bl-maintenance-message'

export default BLMaintenanceMessage
